Date.prototype.format = function(format) {
    var date = {
        'M+': this.getMonth() + 1,
        'd+': this.getDate(),
        'H+': this.getHours(),
        'm+': this.getMinutes(),
        's+': this.getSeconds(),
        'q+': Math.floor((this.getMonth() + 3) / 3),
        'S+': this.getMilliseconds()
    };
    if (/(y+)/i.test(format)) {
        format = format.replace(
            RegExp.$1,
            (this.getFullYear() + '').substr(4 - RegExp.$1.length)
        );
    }
    for (var k in date) {
        if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(
                RegExp.$1,
                RegExp.$1.length === 1
                    ? date[k]
                    : ('00' + date[k]).substr(('' + date[k]).length)
            );
        }
    }
    return format;
};

String.prototype.trim = function() {
    return this.replace(/(^\s*)|(\s*$)/g, '');
};
const fromEntries = arrArg => {
    // Map
    if (Object.prototype.toString.call(arrArg) === '[object Map]') {
        const resMap = {};
        for (const key of arrArg.keys()) {
            resMap[key] = arrArg.get(key);
        }
        return resMap;
    }
    // array
    if (Array.isArray(arrArg)) {
        const resArr = {};
        arrArg.map(([key, value]) => {
            resArr[key] = value;
        });
        return resArr;
    }
    throw new Error('Uncaught TypeError: argument is not iterable');
};

if (!Object.fromEntries) Object.fromEntries = fromEntries;
